import { createFileRoute, redirect } from '@tanstack/react-router'
import { validateListingSearch } from '@/modules/file-manager/lib/folder-search'

/**
 * Where folders reached through a share used to live. A folder has one
 * address now, `/files/$nodeId`, whoever it belongs to; this keeps every link
 * and bookmark made before that working. Replaced, not pushed, so Back does
 * not walk into the redirect again.
 */
export const Route = createFileRoute('/(private)/(shell)/shared/$nodeId/')({
	validateSearch: validateListingSearch,
	beforeLoad: ({ params, search }) => {
		throw redirect({
			params,
			replace: true,
			search,
			to: '/files/$nodeId'
		})
	}
})
